import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _arrayLikeToArray from "@babel/runtime/helpers/arrayLikeToArray";
import _toArray from "@babel/runtime/helpers/toArray";
import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";
export * from "react-i18next";
i18n.use(resourcesToBackend(function (lng, ns) {
  return import("mibaby-frontend/i18n/".concat(lng, "/").concat(ns, ".json"));
})).use(initReactI18next).init({
  fallbackLng: "de",
  defaultNS: "default",
  nsSeparator: "::",
  keySeparator: false,
  returnEmptyString: false,
  initAsync: false,
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  }
});
export { i18n };

/*
 * Util
 */

/**
 * @param obj The object to translate
 * @param paths Direct or deep (dot-notation) keys of the object, supports wildcards
 * @param t Translation function, defaults to i18n.t
 * @returns Translated object
 */
export function translateObject(obj, paths) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : i18n.t;
  return paths.reduce(function (obj, path) {
    return translatePath(obj, path, t);
  }, obj);
}

/**
 * @param obj The object to translate
 * @param path Direct or deep (dot-notation) key of the object, supports wildcards
 * @param t Translation function, defaults to i18n.t
 * @returns Translated object
 */
export function translatePath(val, path) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : i18n.t;
  if (typeof path === "string") path = path.split(".");
  if (typeof path !== "object") path = [path];
  if (!path.length) {
    return t(val);
  }
  var _path = path,
    _path2 = _toArray(_path),
    key = _path2[0],
    rest = _arrayLikeToArray(_path2).slice(1);
  if (val[key]) {
    val = Array.isArray(val) ? _toConsumableArray(val) : _objectSpread({}, val);
    if (key === "*") {
      for (var k in val) val[k] = translatePath(val[k], rest, t);
    } else {
      val[key] = translatePath(val[key], rest, t);
    }
  }
  return val;
}

/*
 * Types
 */
//# sourceMappingURL=index.js.map